export async function downloadPdf(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function isNegativeNumericLiteral(value: string): boolean {
  return /^-\d+(?:\.\d+)?(?:e[+-]?\d+)?$/i.test(value.trim());
}

function escapeCsvField(value: unknown): string {
  let text = value == null ? '' : String(value);
  const isSafeNegativeNumber =
    typeof value === 'number' || (typeof value === 'string' && isNegativeNumericLiteral(text));
  if (text.length > 0 && /^[=+\-@\t\r]/.test(text) && !isSafeNegativeNumber) {
    text = `'${text}`;
  }
  if (text.includes(',') || text.includes('"') || text.includes('\n') || text.includes('\r')) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * Build a CSV string from headers and rows, then trigger a browser download.
 */
export function downloadCsv(
  filename: string,
  headers: string[],
  rows: (string | number | boolean | null | undefined)[][],
  options?: { trailingNewline?: boolean },
) {
  const csvContent =
    [
      headers.map(escapeCsvField).join(','),
      ...rows.map((row) => row.map(escapeCsvField).join(',')),
    ].join('\n') + (options?.trailingNewline ? '\n' : '');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
